import { styled } from '@linaria/react';

export const PopoverContainer = styled.div`
    position: relative;
    display: inline-block;
`;

export const PopoverTrigger = styled.a`
    color: #0078d4;
    cursor: pointer;
    font-weight: 600;
    font-size: 0.75rem;
    text-decoration: none;

    &:hover {
        text-decoration: underline;
        color: #005a9e;
    }
`;

export const PopoverOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
`;

export const PopoverContent = styled.div`
    position: fixed;
    z-index: 1000;
    min-width: 300px;
    max-width: 420px;
    background: white;
    border: 1px solid #ccc;
    border-radius: 6px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
    animation: popoverFadeIn 0.15s ease-out;

    @keyframes popoverFadeIn {
        from {
            opacity: 0;
            transform: translateY(-4px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
`;

export const PopoverHeader = styled.div`
    background: #00007c;
    color: white;
    padding: 0.5rem 0.75rem;
    font-weight: 600;
    font-size: 0.8rem;
    border-radius: 5px 5px 0 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const PopoverCloseButton = styled.button`
    background: none;
    border: none;
    color: white;
    font-size: 1rem;
    cursor: pointer;
    padding: 0 0.25rem;
    line-height: 1;
    opacity: 0.8;

    &:hover {
        opacity: 1;
    }
`;

export const PopoverBody = styled.div`
    padding: 0.75rem;
    font-size: 0.8rem;
    color: #333;
    line-height: 1.5;
    max-height: 40vh;
    overflow-y: auto;

    p {
        margin: 0 0 0.5rem 0;
    }

    ul {
        margin: 0.25rem 0 0 0;
        padding-left: 1.25rem;
    }

    li {
        margin-bottom: 0.25rem;
    }
`;

export const PopoverFileLink = styled.a`
    color: #0078d4;
    cursor: pointer;
    text-decoration: none;
    display: block;
    margin: 0.2rem 0;

    &:hover {
        text-decoration: underline;
        color: #005a9e;
    }

    &::before {
        content: '📄 ';
    }
`;
